import PropTypes from 'prop-types';
import React from 'react';
import Style from './style.scss';
import ScItem from './scItem';
import {StyledParentDiv} from './styledSC';

class ScFolder extends React.Component {
    handleClick() {
        const {children, ...rest} = this.props;
        this.props.handleClick(rest);
    }

    render() {
        return (
            <StyledParentDiv onClick={this.handleClick.bind(this)} className={Style.empty}>
                <ScItem {...this.props} intlObject={this.props.intlObject}
                        reportAnalytics={this.props.reportAnalytics}/>
            </StyledParentDiv>
        );
    }
}

ScFolder.propTypes = {
    children: PropTypes.array,
    intlObject: PropTypes.object.isRequired,
    reportAnalytics: PropTypes.func.isRequired,
    handleClick: PropTypes.func.isRequired
};
export default ScFolder;


// WEBPACK FOOTER //
// ./components/ServiceCatalog/scFolder.js